<template>
<div>
    <div class="switch-button-control">
        <div class="switch-button" :class="{ enabled: isEnabled }" @click="toggle" :style="{'--color': color}">
            <div class="button"></div>
        </div>
        <div class="switch-button-label">
            <slot></slot>
        </div>
    </div>

</div>
</template>

<script>
export default {
    model: {
        prop: "isEnabled",
        event: "toggle"
    },
    props: {
        isEnabled: Boolean,
        color: {
            type: String,
            required: false,
            default: "#4D4D4D"
        },
        id: Number,
        cliente: String
    },
    methods: {
        toggle: function () {
            // console.log("ENTRE");
            if (!this.isEnabled) {

                let options = {
                    'Agendado': 'Agendado',
                    'Sin Horas Disponibles': 'Sin Horas Disponibles',
                    'Ya realizó reagendamiento': 'Ya realizó reagendamiento',
                    'Solicita Información': 'Solicita Información',
                    'Volver a contactar': 'Volver a contactar',
                }

                this.$swal.fire({
                    icon: 'warning',
                    title: "¿Esta Seguro de marcar como revisada?",
                    text: "No podra revertir esta opcion:",
                    input: 'select',
                    inputOptions: options,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Guardar!',
                    cancelButtonText: 'NO!',
                    showCancelButton: true,
                     inputPlaceholder: "Comentario"
                }).then((result) => {
                    if (result.value) {
                        this.$emit('toggle',{id:this.id,comment:result.value})
                    }
                });
            }
        }
    }
}
</script>

<style lang="scss">
.switch-button-control {
    display: flex;
    flex-direction: row;
    align-items: center;

    .switch-button {
        $switch-button-height: 1.6em;
        $switch-button-color: var(--color);
        $switch-button-border-thickness: 2px;
        $switch-transition: all 0.3s ease-in-out;
        $switch-is-rounded: true;

        height: $switch-button-height;
        width: calc(#{$switch-button-height} * 2);
        border: $switch-button-border-thickness solid $switch-button-color;
        box-shadow: inset 0px 0px $switch-button-border-thickness 0px rgba(0, 0, 0, 0.33);
        border-radius: if($switch-is-rounded, $switch-button-height, 0);

        transition: $switch-transition;

        $button-side-length: calc(#{$switch-button-height} - (2 * #{$switch-button-border-thickness}));

        cursor: pointer;

        .button {
            height: $button-side-length;
            width: $button-side-length;
            border: $switch-button-border-thickness solid $switch-button-color;
            border-radius: if($switch-is-rounded, $button-side-length, 0);
            background: $switch-button-color;

            transition: $switch-transition;
        }

        &.enabled {
            background-color: $switch-button-color;
            box-shadow: none;

            .button {
                background: white;
                transform: translateX(calc(#{$button-side-length} + (2 * #{$switch-button-border-thickness})));
            }
        }
    }

    .switch-button-label {
        margin-left: 10px;
    }
}
</style>
